import { render, staticRenderFns } from "./CartUpsells.vue?vue&type=template&id=aed125cc&scoped=true&"
import script from "./CartUpsells.vue?vue&type=script&lang=js&"
export * from "./CartUpsells.vue?vue&type=script&lang=js&"
import style0 from "./CartUpsells.vue?vue&type=style&index=0&id=aed125cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed125cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconAdd: require('/opt/build/repo/components/icons/IconAdd.vue').default})
